import React, { useState, useEffect, useRef } from "react";
import { BiCheckbox } from "react-icons/bi";
import { FaBars, FaTimes } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';

function DlaSpecialRecognitionAwardPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [loading, setLoading] = useState(true);
  const [awardData, setAwardData] = useState(null);
  const headerRef = useRef(null);


  const API_BASE_URL = "https://backend.dlapakistan.com";

  useEffect(() => {
    fetchSpecialRecognitionData();
    
    const updateHeaderHeight = () => {
      const header = document.querySelector('header') || 
                    document.querySelector('.header') ||
                    document.querySelector('#header');
      
      if (header) {
        setHeaderHeight(header.offsetHeight);
      } else {
        if (windowWidth < 640) {
          setHeaderHeight(80);
        } else if (windowWidth < 768) {
          setHeaderHeight(96);
        } else {
          setHeaderHeight(120);
        }
      }
    };

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      updateHeaderHeight();
      if (window.innerWidth > 1029) {
        setIsSidebarOpen(false);
      }
    };

    updateHeaderHeight();
    window.addEventListener("resize", handleResize);
    
    const observer = new ResizeObserver(updateHeaderHeight);
    const headerElement = headerRef.current || 
                         document.querySelector('header');
    if (headerElement) observer.observe(headerElement);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (headerElement) observer.unobserve(headerElement);
    };
  }, [windowWidth]);

  const fetchSpecialRecognitionData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/api/dla-fellowship/special-recognition/get/`);
      
      if (response.data && response.data.success) {
        if (response.data.data) {
          setAwardData(response.data.data);
          localStorage.setItem("specialRecognition_frontend_data", JSON.stringify(response.data.data));
        } else {
          setAwardData(null);
          const savedData = localStorage.getItem("specialRecognition_frontend_data");
          if (savedData) {
            try {
              const parsedData = JSON.parse(savedData);
              setAwardData(parsedData);
            } catch (e) {
              console.error("Error parsing saved data:", e);
            }
          }
        }
      } else {
        const savedData = localStorage.getItem("specialRecognition_frontend_data");
        if (savedData) {
          try {
            const parsedData = JSON.parse(savedData);
            setAwardData(parsedData);
          } catch (e) {
            console.error("Error parsing saved data:", e);
          }
        }
      }
    } catch (error) {
      console.error("Special Recognition GET Error:", error);
      
      const savedData = localStorage.getItem("specialRecognition_frontend_data");
      if (savedData) {
        try {
          const parsedData = JSON.parse(savedData);
          setAwardData(parsedData);
        } catch (e) {
          console.error("Error parsing saved data:", e);
        }
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Connection Issue',
          text: 'Unable to fetch latest data. Showing cached content if available.',
          timer: 2000,
          showConfirmButton: false
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const isMobileView = windowWidth <= 1029;

  const sidebarLinks = [
    { text: "About Us", border: "#ccc", showIcon: false, path: "/about" },
    { text: "Meet the Board", border: "#ccc", showIcon: true, path: "/about/meet-the-board" },
    { text: "Work We Do", border: null, showIcon: true, path: "/about/work-we-do" },
    { text: "Education", border: null, showIcon: false, path: "/about/work-we-do/education" },
    { text: "Regulation", border: null, showIcon: false, path: "/about/work-we-do/regulation" },
    { text: "Membership Support", border: "#ccc", showIcon: false, path: "/about/work-we-do/membership-support" },
    { text: "Our Policies", border: "#ccc", showIcon: true, path: "/about/our-policies" },
    { text: "Become a Member", border: "#ccc", showIcon: true, path: "/about/become-member" },
    { text: "DLA Fellowship", border: null, showIcon: true, path: "/about/dla-fellowship" },
    { text: "DLA Fellowship Awards", border: null, showIcon: true, path: "/about/dla-fellowship/awards" },
    { text: "DLA Special Recognition Award", border: null, showIcon: false, path: "/about/dla-fellowship/special-recognition" },
  ];

  const handleSidebarClick = (path) => {
    navigate(path);
    if (windowWidth <= 1029) {
      setIsSidebarOpen(false);
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleBreadcrumbClick = (path) => {
    navigate(path);
  };

  const mobileOverlayClass = isMobileView && isSidebarOpen ? "pt-0" : "";

  return (
    <div 
      className={`w-full min-h-screen ${mobileOverlayClass}`}
      ref={headerRef}
    >
      
      <div className="w-full px-4 mt-52 sm:px-6 md:px-8 lg:px-10 xl:px-12 mx-auto">
        
        <div className="flex flex-wrap items-center text-gray-500 mb-4 md:mb-6 text-sm md:text-base">
          <span 
            className="cursor-pointer hover:underline hover:text-[#70B444] transition-colors"
            onClick={() => handleBreadcrumbClick("/")}
          >
            Home
          </span> 
          <span className="mx-2">»</span>
          <span 
            className="cursor-pointer hover:underline hover:text-[#70B444] transition-colors"
            onClick={() => handleBreadcrumbClick("/about")}
          >
            About The DLA
          </span>
          <span className="mx-2">»</span>
          <span className="text-[#70B444] font-medium">
            DLA Special Recognition Award
          </span>
        </div>

        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 relative pb-8 md:pb-12">
          
          {!isMobileView && (
            <div className="w-full lg:w-72 xl:w-80 shrink-0 bg-[#f7f9fc] p-4 md:p-5 rounded-lg shadow-sm h-fit sticky top-24">
              <div className="bg-[#70B444] text-white p-3 text-center mb-4">
                <h3 className="m-0 text-base lg:text-lg font-semibold">About The DLA</h3>
              </div>
              {sidebarLinks.map((item, index) => (
                <div
                  key={index}
                  onClick={() => handleSidebarClick(item.path)}
                  className={`flex items-center py-2.5 text-[#70B444] font-medium cursor-pointer transition-all hover:bg-[rgba(112,180,68,0.1)] px-2 text-sm lg:text-base ${
                    item.border ? "border-b border-gray-200" : ""
                  } ${location.pathname === item.path ? "bg-[rgba(112,180,68,0.1)] border-l-4 border-l-[#70B444]" : ""}`}
                >
                  {item.showIcon && <BiCheckbox className="mr-2 text-lg flex-shrink-0" />}
                  <span className="break-words">{item.text}</span>
                </div>
              ))}
            </div>
          )}

          <div className={`flex-1 ${isMobileView ? 'p-0' : 'p-2 md:p-4'} ${
            isMobileView && isSidebarOpen ? "opacity-30 pointer-events-none" : "opacity-100"
          }`}>
            
            <div className="flex justify-between items-center border-b-2 border-[#70B444] pb-3 md:pb-4 mb-4 md:mb-6">
              <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-[#70B444] leading-snug">
                DLA Special Recognition Award
              </h1>
              
              {isMobileView && (
                <button
                  onClick={toggleSidebar}
                  className="flex items-center gap-2 text-[#70B444] border border-[#70B444] rounded-lg px-3 py-2 hover:bg-[#70B444] hover:text-white transition-all text-sm font-semibold shrink-0"
                >
                  {isSidebarOpen ? <FaTimes /> : <FaBars />}
                  <span>{isSidebarOpen ? "Close" : "Menu"}</span>
                </button>
              )}
            </div>

            {loading ? (
              <div className="flex justify-center items-center py-20">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#70B444]"></div>
              </div>
            ) : awardData ? (
              <div className="space-y-6 md:space-y-8">
                <div className="mb-6 md:mb-8">
                  <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3">
                    {awardData.title}
                  </h2>
                </div>
                
                <div className="prose prose-lg max-w-none">
                  <div 
                    className="text-gray-700 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: awardData.description || "" }}
                  />
                </div>
              </div>
            ) : (
              <div className="text-center py-12 md:py-16">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 mb-4">
                  <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-700 mb-2">No Content Available</h3>
                <p className="text-gray-500 mb-6">Special Recognition Award content has not been added yet.</p>
                <button 
                  onClick={fetchSpecialRecognitionData}
                  className="px-6 py-3 bg-[#70B444] text-white rounded-lg hover:bg-opacity-90 transition-all font-medium"
                >
                  Refresh
                </button>
              </div>
            )}
          </div>

          {isMobileView && (
            <div
              className={`fixed top-0 right-0 h-full w-[85vw] max-w-sm bg-white z-[60] shadow-2xl transform transition-transform duration-300 ease-in-out ${
                isSidebarOpen ? "translate-x-0" : "translate-x-full"
              }`}
              style={{ top: `${headerHeight}px`, height: `calc(100vh - ${headerHeight}px)` }}
            >
              <div className="flex flex-col h-full">
                <div className="p-4 border-b flex justify-between items-center bg-[#70B444] text-white">
                  <span className="font-bold text-lg">Navigation</span>
                  <FaTimes 
                    className="cursor-pointer text-2xl" 
                    onClick={toggleSidebar} 
                  />
                </div>
                <div className="overflow-y-auto flex-1 p-2">
                  {sidebarLinks.map((item, index) => (
                    <div
                      key={index}
                      onClick={() => handleSidebarClick(item.path)}
                      className={`p-3 md:p-4 text-base border-b border-gray-100 flex items-center hover:bg-gray-50 ${
                        location.pathname === item.path 
                          ? "text-[#70B444] font-semibold bg-green-50 border-l-4 border-l-[#70B444]" 
                          : "text-gray-700"
                      }`}
                    >
                      {item.showIcon && <BiCheckbox className="mr-3 text-xl text-[#70B444] flex-shrink-0" />}
                      <span>{item.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {isMobileView && isSidebarOpen && (
            <div
              className="fixed inset-0 bg-black/50 z-[50] transition-opacity"
              style={{ top: `${headerHeight}px` }}
              onClick={toggleSidebar}
            />
          )}
        </div>
      </div>

      <style jsx>{`
        .prose :global(p) {
          margin-bottom: 1.5rem;
          line-height: 1.8;
        }
        .prose :global(ul) {
          list-style-type: disc;
          padding-left: 1.5rem;
          margin-bottom: 1.5rem;
        }
        .prose :global(ol) {
          list-style-type: decimal;
          padding-left: 1.5rem;
          margin-bottom: 1.5rem;
        }
        .prose :global(li) {
          margin-bottom: 0.5rem;
        }
        .prose :global(h2) {
          color: #70B444;
          font-size: 1.875rem;
          font-weight: bold;
          margin-top: 2rem;
          margin-bottom: 1rem;
        }
        .prose :global(h3) {
          color: #70B444;
          font-size: 1.5rem;
          font-weight: bold;
          margin-top: 1.5rem;
          margin-bottom: 1rem;
        }
      `}</style>
    </div>
  );
}

export default DlaSpecialRecognitionAwardPage;